// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/frontend and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import { loadControllersForPage } from "../stimulus/lazy_load"

const EAGER_IDENTIFIERS = new Set([
  'navbar',
  'menu-slideout',
  'modal',
  'briefing',
  'dropzone',
  'from-url',
  'cookies-bar',
])

const application = Application.start()
const eagerContext = require.context(
  "../controllers",
  true,
  /\/(navbar|menu_slideout|modal|briefing|dropzone|from_url|cookies_bar)_controller\.js$/
)
application.load(definitionsFromContext(eagerContext))

document.addEventListener('turbolinks:load', () => {
  loadControllersForPage(application, EAGER_IDENTIFIERS)
})

/**
 * Will be extracted and imported with stylesheet_packs_with_chunks_tag 'application'
 */
import '../stylesheets/application.scss';
require.context('../images', true)

/**
 * Will load the view_components javascript and css files
 */
function importAll(r) {
  r.keys().forEach(r)
}

importAll(require.context("../../components", true, /_component.js$/))
importAll(require.context("../../components", true, /_component.scss$/))

/* Lozad initialization */

import lozad from 'lozad';

const initLozad = () => {
  const observer = lozad();
  observer.observe();
};

document.addEventListener('turbolinks:load', initLozad)
